<template>
  <div>
    <!-- 《登记须知》弹窗 -->
    <el-dialog center title="登记须知" :visible.sync="showRegisterEquirements" @closed="onCloseRegisterEquirements">
        <div class="registerEquirementsBox">
        <h2>尊敬的登记申请人：</h2>
        <p>在提交作品前，请务必确认以下事项：</p>
        <h3>一、原创性声明​​</h3>
        <p>1. 作品自愿登记仅接受原创作品登记，请确保您是该作品的真实著作权人。</p>
        <p>2. 若作品涉及改编、演绎现有作品（如翻译、改编歌曲等），须在登记时主动声明并提供原著作权人的授权证明。</p>
        <h3>二、资料生成提示</h3>
        <p>1. 著作权人管理页面中，添加个人、法人著作权人时，上传的电子签名与印章图案仅用于版权登记材料（个人作品为附件一、二，法人作品为附件一、二、三）生成，不存在任何其他用途，系统会对其安全储存。请妥善保管好您的账号，由账号泄漏导致的影响与损失与本平台无关。</p>
        <p>2. 作品简介与创作过程为著作权人对原创内容真实情况的介绍与表达，应由著作权人自行填写。如果您没有填写作品简介与创作过程，视同授权本系统代为填写，系统处理后会自动生成相关内容，生成的内容视为著作权人对作品的真实表达。期间所有作品样本数据传输带来的相关风险与本平台无关。</p>
        <h3>三、法律风险警示​​</h3>
        <p>1. 登记证书不是原创性的绝对证明！若登记非原创作品：</p>
        <p>（1）将导致登记无效，面临强行撤销证书，已缴费用不予退还。</p>
        <p>（2）可能成为侵害他人著作权的证据，面临民事赔偿或行政处罚。</p>
        <p>（3）情节严重者可能触犯《刑法》第217条"侵犯著作权罪"。</p>
        <h3>四、诚信承诺​​</h3>
        <p>使用登记代理服务即视为您承诺：</p>
        <p>1. 作品权利归属方式与真实情况一致，如涉及他人作品已合法取得授权。</p>
        <p>2. 已知晓虚假登记的法律责任。</p>
        <p>3. 授权我司在必要时对作品原创性进行核查。</p>
        <p class="lastP">如对作品权属存疑，建议先行咨询专业法律人士。感谢您对版权保护的重视与配合！</p>
        <span>附件一</span>
        <!-- <img src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/right_guarantee.jpg" alt=""> -->
        <img src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/quanlibaozheng.png" alt="">
        <span>附件二</span>
        <img src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/attorney.jpg" alt="">
        <!-- <img src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/quanshu_zhiwu.png" alt=""> -->
        <!-- <img src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/quanshu_weituojiafang.png" alt=""> -->
        <span>附件三</span>
        <img src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/quanshu_faren.png" alt="">
        
        </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "",
  data() {
    return {
      showRegisterEquirements: false,
    };
  },
  created() {
    
  },
  methods: {
    showDialog() {
        this.showRegisterEquirements = true;
    },
    onCloseRegisterEquirements(){
      this.showRegisterEquirements = false;
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/.el-dialog{min-height: 85vh;margin-top: 50px!important;width: 40%;min-width: 600px;}
.registerEquirementsBox h2{font-size: 16px;}
.registerEquirementsBox h3{font-size: 14px;margin-top: 20px;line-height: 24px;}
.registerEquirementsBox p{font-size: 14px;line-height: 24px;}
.registerEquirementsBox p.lastP{margin-top: 20px;margin-bottom: 50px;}
.registerEquirementsBox span{display: block;width: 100%;line-height: 20px;font-size: 12px;text-align: center;margin-top: 20px;margin-bottom: 10px;position: relative;}
.registerEquirementsBox span::before{content: '';width: calc(50% - 50px);height: 1px;background: #999;position: absolute;left: 0;top: 10px;opacity: 0.5;}
.registerEquirementsBox span::after{content: '';width: calc(50% - 50px);height: 1px;background: #999;position: absolute;right: 0;top: 10px;opacity: 0.5;}
.registerEquirementsBox img{width: 100%;height: auto;box-shadow: 0px 0px 10px 0px rgba(2,37,116,0.08);margin-bottom: 20px;}
</style>
